import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { equals } from "ramda";
import { extendedSystemStylesProps } from "@mixins";
import tableWrapperStyles, { styledSystemKeys } from "./tableWrapper.styles.js";
import { isNotEmptyArray } from "utils/validation";
import { sortIcon } from "utils/sort";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function TableHeaderWrapper(props) {
  var _column$sortOptions;
  var column = props.column,
    colIndex = props.colIndex,
    activeSort = props.activeSort,
    setActiveSort = props.setActiveSort,
    translatedSort = props.translatedSort;
  var Th = tableWrapperStyles.Th,
    ColumnLabel = tableWrapperStyles.ColumnLabel,
    SortableColumn = tableWrapperStyles.SortableColumn;
  var isActiveSort = (_column$sortOptions = column.sortOptions) === null || _column$sortOptions === void 0 ? void 0 : _column$sortOptions.includes(activeSort);
  var handleSort = function handleSort() {
    return setActiveSort(function (old) {
      return column.sortOptions.includes(old) ? column.sortOptions.find(function (x) {
        return !equals(old, x);
      }) : column.sortOptions[0];
    });
  };
  if (isNotEmptyArray(column.sortOptions)) return /*#__PURE__*/_jsx(Th, {
    scope: "col",
    "aria-sort": isActiveSort && translatedSort || "none",
    "aria-colindex": colIndex + 1,
    children: /*#__PURE__*/_jsxs(SortableColumn, {
      onClick: handleSort,
      icon: sortIcon(translatedSort),
      active: isActiveSort,
      textAlign: column.align || "",
      p: column.padding || "",
      children: [column.label, /*#__PURE__*/_jsx("span", {
        className: "hidden-styles",
        children: "Aktivera f\xF6r att sortera kolumnen"
      })]
    })
  });
  return /*#__PURE__*/_jsx(Th, _objectSpread(_objectSpread({
    scope: "col",
    "aria-colindex": colIndex + 1
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: /*#__PURE__*/_jsx(ColumnLabel, {
      textAlign: column.align || "",
      p: column.padding || "",
      children: column.label
    })
  }));
}